export default __webpack_public_path__ + "96fe2fde040d4eaeb1063c01d2afb889.png";